module.exports = __webpack_public_path__ + "static/media/app_iris_interact.a0ce8546.png";